import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsStagesProgress(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_STAGES_PRODUCTS,dtConfig[ModulesMap.REPORTS_STAGES_PRODUCTS].getReportsStagesProgress,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsStagesProgress,
}
